import LangProvider, { useLangContext } from './LangProvider';

export { useLangContext };
export default LangProvider;
